import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  DEFECT_ACCEPTED,
  DEFECTED,
  DISCUSS_APPROVED,
  DISCUSS_FINISHED,
  DISCUSS_FINISHED_ACCEPTED,
  DISCUSS_FINISHED_ACCEPTED_WITH_LEGAL_GROUND,
  DISCUSS_FINISHED_REJECTED,
  DISCUSS_FINISHED_REJECTED_WITH_LEGAL_GROUND,
  DISCUSS_REJECTED,
  DISCUSS_REJECTED_AND_WITH_LEGAL_GROUND,
  NEW,
  VIOLATED,
  VIOLATED_PUBLISHED,
  VOTE_COMPLETED,
  VOTE_IN_PROGRESS,
  VOTE_INCOMPLETE
} from '../../../../../services/admin/constants';
import { AdminService } from '../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  filterFormGroup: FormGroup;
  categoryOptions = [];
  statusOptions = [
    NEW,
    VOTE_IN_PROGRESS,
    VIOLATED,
    VIOLATED_PUBLISHED,
    VOTE_COMPLETED,
    VOTE_INCOMPLETE,
    DISCUSS_APPROVED,
    DISCUSS_REJECTED,
    DISCUSS_REJECTED_AND_WITH_LEGAL_GROUND,
    DEFECTED,
    DEFECT_ACCEPTED,
    DISCUSS_FINISHED,
    DISCUSS_FINISHED_ACCEPTED,
    DISCUSS_FINISHED_ACCEPTED_WITH_LEGAL_GROUND,
    DISCUSS_FINISHED_REJECTED,
    DISCUSS_FINISHED_REJECTED_WITH_LEGAL_GROUND
  ];

  @Output() filter = new EventEmitter<object>();

  constructor(
    private _adminService: AdminService,
    private _loadingService: TdLoadingService
  ) {}

  ngOnInit() {
    this._getCategoryOptions();
  }

  private _initializeForm() {
    this.filterFormGroup = new FormGroup({
      id: new FormControl(),
      authorFullName: new FormControl(),
      title: new FormControl(),
      categoryId: new FormControl(),
      statusIds: new FormControl()
    });
  }

  private _getCategoryOptions() {
    this._loadingService.register();
    this._adminService.findCategories().subscribe((res: any) => {
      this._loadingService.resolve()
      this.categoryOptions.push(...res.result.data);
      this._initializeForm();
    });
  }

  submit() {
    this.filter.emit(this.filterFormGroup.value);
  }

  resetForm() {
    this.filterFormGroup.reset();
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/admin-idea-all/filter/filter.component.ts